export default "__VITE_PUBLIC_ASSET__3e989fb2__"